export default __webpack_public_path__ + "static/media/skillset-automation.cc11cae1.svg";